import { Box, Typography, CardMedia } from '@mui/material'

const ImageQuestion = ({
  question,
  id,
  imageUrl,
}: {
  question: string
  id: string
  imageUrl: string
}) => {
  return (
    <Box key={id}>
      <Typography variant="body1"> {question} </Typography>
      <CardMedia
        component="img"
        sx={{ maxWidth: '100%' }}
        image={imageUrl}
        alt={question}
      />
    </Box>
  )
}

export default ImageQuestion
